export default "__VITE_ASSET__d71bba13__"